const GROUP_INVITE_PATH_REGEX = /\/messenger\/groups\/join\/([^/?#\s]+)/;

export const MESSENGER_GROUP_INVITE_EVENT = "messenger:group-invite";

export type MessengerGroupInviteDetail = {
  token: string;
};

export function parseGroupInviteToken(url: string): string | null {
  try {
    const parsed = new URL(url, window.location.origin);
    const match = parsed.pathname.match(GROUP_INVITE_PATH_REGEX);
    return match?.[1] ? decodeURIComponent(match[1]) : null;
  } catch {
    const match = url.match(GROUP_INVITE_PATH_REGEX);
    return match?.[1] ? decodeURIComponent(match[1]) : null;
  }
}

export function dispatchGroupInviteLink(token: string): boolean {
  const event = new CustomEvent<MessengerGroupInviteDetail>(
    MESSENGER_GROUP_INVITE_EVENT,
    {
      detail: { token },
      cancelable: true,
    },
  );
  window.dispatchEvent(event);
  return event.defaultPrevented;
}
